const tab_sections = {
    overview: 'Genel Bakış',
    authentication: 'Kimlik doğrulama',
    authorization: 'Yetkilendirme',
    users: 'Kullanıcılar',
    developer: 'Geliştirici',
    tenant: 'Kiracı',
};
export default Object.freeze(tab_sections);
